// client/src/lib/currency.js
// Camp-level currency presentation. The stored Transaction.amount is a
// unitless number (whole for STAR camps, up to 2 decimal places for
// SHEKEL/DOLLAR); this module is the only thing that knows what symbol
// to render and how to render fractions.
//
// Display rule (same on terminal / kiosk / voucher print): integer
// amounts render with no decimals ("10"), fractional amounts render
// with exactly 2 ("10.50" — never "10.5", which misreads as 10.05).
//
// CampCurrency enum mirrors prisma/schema.prisma — SHEKEL is the
// default for legacy / unset values.

export const CURRENCIES = {
  SHEKEL: { code: 'SHEKEL', symbol: '₪', label: 'שקל' },
  DOLLAR: { code: 'DOLLAR', symbol: '$', label: 'דולר' },
  STAR: { code: 'STAR', symbol: '⭐', label: 'כוכב' },
};

export function getCurrency(code) {
  return CURRENCIES[code] || CURRENCIES.SHEKEL;
}

/** Bare number under the display rule: "47" / "47.50". null → "—". */
export function formatNumber(n) {
  if (n == null) return '—';
  const r = Math.round(n * 100) / 100;
  return Number.isInteger(r)
    ? r.toLocaleString('he-IL')
    : r.toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** "₪47" / "$47.50" / "⭐47". Pass null/undefined to get "—". */
export function formatAmount(n, currencyCode) {
  if (n == null) return '—';
  return getCurrency(currencyCode).symbol + formatNumber(n);
}

/** Plain symbol — useful where you just need to label an input field. */
export function currencySymbol(currencyCode) {
  return getCurrency(currencyCode).symbol;
}
